import React from 'react';
import { NavButton as Button, DropDownIcon } from '../../styles/navbar.style';
import Chevron_down from '../../../../images/Icons/chevron_down.svg';
import { NAV_ITEMS } from '../../constants';
import PropTypes from 'prop-types';

const NavButton = ({ onClick, isActive, data, ...props }) => {
    return (
        <Button onClick={onClick} active={isActive} {...props}>
            <span>{data.label}</span>
            {data.label !== NAV_ITEMS.PRICING && (
                <DropDownIcon src={Chevron_down} alt="arrow-down" />
            )}
        </Button>
    );
};

NavButton.propTypes = {
    onClick: PropTypes.func,
    isActive: PropTypes.bool,
    data: PropTypes.object,
};

export default NavButton;
